import { FC } from 'react';
import { Link } from '@tanstack/react-router';

import { RoamlerLogo } from '@/components/blocks/shared/roamler-logo';
import { useAppConfig } from '@/hooks/use-app-config';
import { cn } from '@/lib/utils';

interface NavLogoTopbarProps {
  className?: string;
}

export const NavLogoTopbar: FC<NavLogoTopbarProps> = ({
  className,
}: NavLogoTopbarProps) => {
  const { name } = useAppConfig();
  return (
    <div className={cn('flex items-center', className)}>
      <Link
        data-testid='topbar-home'
        to='/'
        className='flex items-center gap-2.5'>
        {/* Only the orange hexagon: the wordmark starts past x=41. */}
        <RoamlerLogo
          viewBox='0 0 41.4 46'
          className='h-7 w-auto'
        />
        <span className='text-foreground truncate text-base font-bold tracking-tight'>
          {name}
        </span>
      </Link>
    </div>
  );
};
